export default __webpack_public_path__ + "static/media/lesnik_summer_04.2eb069bc.svg";